module.exports = function() {
  return new Worker(__webpack_public_path__ + "6c0207c141e50a0251c3.worker.js");
};